import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Tent, Menu } from "lucide-react";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="p-2 bg-gradient-hero rounded-lg group-hover:scale-105 transition-transform">
              <Tent className="h-5 w-5 text-primary-foreground" />
            </div>
            <span className="text-xl font-display font-bold text-foreground">
              SiteBook
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-4">
            <Link to="/about">
              <Button variant="ghost">About</Button>
            </Link>
            <Link to="/booking-simplified">
              <Button variant="ghost">Booking</Button>
            </Link>
            <Link to="/faq">
              <Button variant="ghost">FAQ</Button>
            </Link>
            <Link to="/contact">
              <Button variant="ghost">Contact</Button>
            </Link>
            <a href="https://sitebook.uk/join">
              <Button className="bg-gradient-hero hover:opacity-90 transition-opacity">
                Join SiteBook
              </Button>
            </a>
            <Link to="/auth">
              <Button variant="ghost">Sign In</Button>
            </Link>
            <Link to="/auth?mode=signup">
              <Button variant="outline">Sign Up</Button>
            </Link>
          </div>

          {/* Mobile Burger Menu */}
          <div className="md:hidden">
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-72">
                <div className="flex flex-col gap-4 mt-8">
                  <Link to="/about" onClick={() => setOpen(false)}>
                    <Button variant="ghost" className="w-full justify-start">About</Button>
                  </Link>
                  <Link to="/booking-simplified" onClick={() => setOpen(false)}>
                    <Button variant="ghost" className="w-full justify-start">Booking</Button>
                  </Link>
                  <Link to="/faq" onClick={() => setOpen(false)}>
                    <Button variant="ghost" className="w-full justify-start">FAQ</Button>
                  </Link>
                  <Link to="/contact" onClick={() => setOpen(false)}>
                    <Button variant="ghost" className="w-full justify-start">Contact</Button>
                  </Link>
                  <a href="https://sitebook.uk/join" onClick={() => setOpen(false)}>
                    <Button className="w-full bg-gradient-hero hover:opacity-90 transition-opacity">
                      Join SiteBook
                    </Button>
                  </a>
                  <Link to="/auth" onClick={() => setOpen(false)}>
                    <Button variant="ghost" className="w-full justify-start">Sign In</Button>
                  </Link>
                  <Link to="/auth?mode=signup" onClick={() => setOpen(false)}>
                    <Button variant="outline" className="w-full">Sign Up</Button>
                  </Link>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};
